import { useState } from "react";
import { Download, X } from "lucide-react";

export function installAppUrl(page = "download") {
  const url = new URL("https://xihaia.com/");
  if (page === "tutorial") url.hash = "installation";
  const code = new URLSearchParams(window.location.search).get("ref");
  if (code && /^XH[A-Z0-9]{10}$/.test(code)) url.searchParams.set("ref", code);
  return url.toString();
}

export function InstallAppBanner() {
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem("west-coast-install-dismissed") === "true"; } catch { return false; }
  });
  const standalone = window.matchMedia("(display-mode: standalone)").matches || Boolean((navigator as Navigator & { standalone?: boolean }).standalone);
  if (dismissed || standalone) return null;
  return <aside className="coast-install-banner" aria-label="安装西海岸桌面入口">
    <button type="button" aria-label="关闭安装提示" onClick={() => { setDismissed(true); try { sessionStorage.setItem("west-coast-install-dismissed", "true"); } catch { /* In-memory dismissal still works. */ } }}><X aria-hidden="true"/></button>
    <img src="/assets/west-coast/app-icon.png" width="42" height="42" alt=""/>
    <div><strong>西海岸 APP</strong><span>添加至桌面，便捷访问</span></div>
    <a href={installAppUrl()}>立即下载<Download aria-hidden="true"/></a>
  </aside>;
}
